module.exports = __webpack_public_path__ + "img/photo.d50b43dd.png";